








import { Vue, Component } from 'vue-property-decorator'
import Main from './components/Main/index.vue'
import { MainHead } from '@/components/index'
import { AllObjectList } from '@/api/ObectAdmin'
import { ResAllObjectList } from '@/types/ObjectAdmin'
@Component({
  components: {
    MainHead,
    Main,
  },
})
export default class extends Vue {
  /**
   * headTitle 头部标题
   * headData  头部展示数据
   * HeadImg   头部右侧图片
   * listArr   接口返回列表数据
   *
   * ResAllObjectList  接口规则
   */

  headTitle: string = '分群管理';
  headData: string[] = [
    '创建并维护各对象的分群，并对分群中的对象实例进行分析。',
    '在创建和维护分群前，请先选择对象。',
  ];

  HeadImg: string = require('@/assets/images/add_object.png');
  listArr: ResAllObjectList[] = [];
  created() {
    this.getAllObjectList()
  }
  async getAllObjectList() {
    const { data } = await AllObjectList()
    this.listArr = data
  }
}
